var winHeight = "";
var winWidth = "";
var $jquery = (typeof $jquery != 'undefined') ? $jquery : $;
var originalLeave = null;
var headerHeight = "";
var isSampleOrder = false;

$(document).ready(function() {
  // Call these functions when the document is ready
  initSlick();
  openModalFromUrlParameter();
  shortHeight();
  tabHeights();
  setAllEqualHeights();
  // Do not show hexes in the cart
  if (!window.location.pathname.includes('/cart')) {
    hexes();
  }

  function hexes() {
    var ResizeTimer = null;
    $(window).resize(function() {
      if(ResizeTimer != null) window.clearTimeout(ResizeTimer);
      ResizeTimer = window.setTimeout(function() {
        screensize();
      }, 200);
    });
    // initial draw
    screensize();

    function randcolor() {
      const colors = ['#021d49', '#00babc', '#52b7ba', '#84dade', '#bbe7e9', '#d0d3d4', '#84d9dd', '#00b9ba']; 
      return colors[Math.floor(Math.random() * colors.length)];
    }

    function draw(numHexes, numRand, tilt) {
      $('div.hex').remove();
      for (var i = 1; i < numHexes; i++) {
        $( "<div class='hex'></div>" ).appendTo( ".hex-container" ).css('background', randcolor());
      }
      var rand = [];
      for (var j = 0; j <= numRand; j++) {
        rand[j] = Math.floor(Math.random() * numHexes + 1 );
        $('div.hex:nth-of-type('+rand[j]+')').css('background','transparent');
      }
      $('.hexes').css('transform','rotate('+tilt+'deg');
    }

    function screensize() {
      var screenWidth = window.innerWidth;
      if (screenWidth > 2001) {
        draw(100, 35, 10);
        return;
      }
      if (screenWidth < 2000 && screenWidth > 951 ) {
        draw(100, 35, 15);
        return;
      }
      if (screenWidth < 950) {
        draw(16, 5, 0);
        return;
      } 
    }
  }

  if (!$( "#content-mobile" ).length) {
    $('.page-control h3 .arrow').hide();
  }
  
  $('.search_area, li.search-close').click(function () {
    //$('.search-form').toggleClass('form-open');
    $(this).children('.iconSearch').toggleClass('icon_search');
    $(this).children('.iconSearch').toggleClass('icon_close');
    if ($('.icon_close').is(':visible')){
      $('.icon_close').attr("aria-label", "Close Search");
    }
    $('li.cart-item').toggleClass('cart-item-hide');     
    if (!$(this).children('.iconSearch')[0].classList.contains('icon_search')) {
      $('#st-search-input').focus(); 
    }
  });
  
  $('body').on('touchend click', '.footer-box-menu-section .search_btn', function (event) {
    event.preventDefault();
    $('.search-form-footer').toggleClass('form-open');
    if ($('.search-form-footer')[0].classList.contains('form-open')) {
      $('#footer-search-textinput').focus(); 
    }
  });
  
  $('.close_search').click(function () {
    $('.search-form-footer').removeClass('form-open');
  });
  /* Product sort */
  $('.product-sorting-trigger').on('click', function (e) {
      e.stopPropagation();
      $('#sort-by-list').slideToggle();
      $(this).find('.arrow').toggleClass('arrow-active');
      $('body').toggleClass('product-shorting-active');
  });
  $(document).mouseup(function(e){
    //close popup if clicked outside of the box
    var sortContainer = $(".sort-by");
    if (!sortContainer.is(e.target) && sortContainer.has(e.target).length === 0 && sortContainer.hasClass('active')){
        $('.product-sorting-trigger').click();
    }
  });
  /* Product sort mobile */
  $('.short-trigger, .closeShort').click(function () {
      $('.header, .top-bar').css('z-index', '1');
      $('body').toggleClass('active-short');
      $('html').toggleClass('scrollHide');
  });
   /* Product filter mobile */
  $('.filter-trigger, .closeFilter').click(function () {
      $('body').toggleClass('active-filter');
      if( $(window).width() < 767 ) {
        if (typeof hideFilters === 'function') {
          hideFilters();
        }
        // Show/hide sticky-filter-sort based on the clicked element
        if ($(this).hasClass('filter-trigger')) {
          $('.sticky-filter-sort').hide();
          $('.collection-filter-header').addClass('hide-before');
        } else if ($(this).hasClass('closeFilter')) {
          $('.sticky-filter-sort').show();
          $('.collection-filter-header::before').removeClass('hide-before');
        }
      }
      $('html').toggleClass('scrollHide');
      $('.product-sort-wrap').css('z-index', '1');
  });
  /* Mobile product sizing tab */
  $('.productSizeLink, .closeProductSizeLink').click(function () {
      $('body').toggleClass('activeProductSizeLink');
      $('html').toggleClass('scrollHide');
  });
  /* Mobile product details tab */
  $('.productDetailLink, .closeProductDetails').click(function () {
      $('body').toggleClass('activeProductDetail');
      $('html').toggleClass('scrollHide');
  });
  /* Mobile custom reviews tab */
  $('.productReviewLink, .closeProductReviewLink').click(function () {
      $('body').toggleClass('activeProductReviewLink');
      $('html').toggleClass('scrollHide');
  });
  /* Mobile Shipping & Delivery */
  $('.productShippingLink, .closeProductShippingLink').click(function () {
      $('body').toggleClass('activeProductShippingLink');
      $('html').toggleClass('scrollHide');
  });
  
  $('.navbar .dropdown > a').click(function(){
      location.href = this.href;
  });
  

// -------------- new nav 2024 ------------------------

$(function() {

// add class 'selected' to hovered li links
  $('.flyout li').on('mouseover mouseout', function() {
    $(this).toggleClass('selected');
  });

// the following functions handle clicks on the nav menu levels for both desktop and mobile
function handleItemClick(link, level) {
  var firstLevel = link.find('.level-'+level).first();
  firstLevel.show();
  returnTo(link, level);
    if (!firstLevel.hasClass('link-added')) {  
    // inject a link to return to the last level
    var thelink = link.text().trim().split('\n')[0];
    var insertedLink = $('<p class="returnTo"><a name="#'+thelink+'">'+thelink+'</a></p>');
    if ( firstLevel.find($('.slider')).length > 0 ) {
      firstLevel.find($('.slider')).before(insertedLink);
    } else {
      firstLevel.find($('li')).first().before(insertedLink);
    }
    firstLevel.addClass('link-added');
  }
  //returnTo(link, level);
  // refresh slider if active
  var menuSlider = firstLevel.find('.navSlider');
  if ( $(window).width() > 768 ) {
    if ( menuSlider.length > 0 ) {
      menuSlider.slick('refresh'); 
    }
  } else {
    // slick refresh causing issues with mobile nav clicks
    if ( menuSlider.length > 0 ) {
      menuSlider.slick('slickGoTo', 0);
    }
  }
 
}

// handles a link to return to the last level menu
  function returnTo(link, level){
    if (window.screen.availWidth < 767){
      $('.level-'+level).on('touchend', 'p.returnTo', function(e) {
        e.stopPropagation();
        $('.level-'+level).hide();
        $('.level-'+level-1+' li.selected1').removeClass('selected1');
      })
    } else {
      $('.level-'+level).on('click', 'p.returnTo', function(e) {
        e.stopPropagation();
        $('.level-'+level).hide();
        $('.level-'+level-1+' li.selected1').removeClass('selected1');
        $(link).on('mouseover', function() {
          $(this).removeClass('selected1');
        });
      })
    }
    return;
  }

var shouldHandleClick = true;
function determineScrollIntent(callback) {
  var navMenuContainer = $('.flyout');
  var isScrolling = false; // Flag to track scrolling state
  navMenuContainer.on("touchstart", function(e) {
    var initialTouchPosition = e.originalEvent.touches[0].clientY;
    navMenuContainer.on("touchmove", function(event) {
      var currentTouchPosition = event.originalEvent.touches[0].clientY;
      var scrollDelta = currentTouchPosition - initialTouchPosition;
      if (Math.abs(scrollDelta) > 1) { // small threshold for scroll
        isScrolling = true; 
        shouldHandleClick = false; // Don't handle click when scrolling
        callback(isScrolling); // Call the callback with the scrolling state
      }
    });
  });
  navMenuContainer.on("touchend", function() {
    // Reset isScrolling after touchend event
    isScrolling = false;
    callback(isScrolling);
    shouldHandleClick = true; // Reset shouldHandleClick after scrolling ends
  });
}

// Event handling for small screens
if (window.screen.availWidth < 767) {
  // allow scroll on open menu without handling a click on menu items
  determineScrollIntent(function(isScrolling) {
    if (!isScrolling && shouldHandleClick) {
      $(document).on('touchend', '.flyout.level-1 li', function() {
        var link = $(this);
        handleItemClick(link, 2);
      });
      $(document).on('touchend', '.flyout.level-2 li', function() {
        var link = $(this);
        handleItemClick(link, 3);
      });
    } else {
      // If scrolling occurred, unbind the click event handlers
     $(document).off('touchend', '.flyout.level-1 li');
     $(document).off('touchend', '.flyout.level-2 li');
    }
  });
} else {
// Event handling for large screens
    $(document).on('click', '.flyout.level-1 li', function() {
      var link = $(this);
      handleItemClick(link, 2);
    });

    $(document).on('click', '.flyout.level-2 li', function() {
      var link = $(this);
      handleItemClick(link, 3);
    });
  }

// Flag to track menu state
  var isMenuOpen = false;
// handle clicks on menu triggers
  $(document).on('click touchend', 'button.menu-s, button.menu-t', function(e) {
    e.preventDefault();
    var container = $('.menu-container');
    isMenuOpen = container.hasClass('selected');
    container.toggleClass('selected', !isMenuOpen);
    container.toggle(!isMenuOpen);
    $('.level-1').toggle(!isMenuOpen);
    $('.menu-s').toggleClass('selected', !isMenuOpen);
    $('.bar').toggleClass('x', !isMenuOpen);
    $('#page-content, footer').css({'opacity': isMenuOpen ? '1' : '0.5', 'transition': 'opacity 1.25s' });
    e.stopPropagation();
  });


//open menu on destop menu button mouseover
  $('button.menu-s').on('mouseover', function(e) {
    e.preventDefault();
    var container = $('.menu-container');
    isMenuOpen = container.hasClass('selected');
    if (!isMenuOpen) {
    container.toggleClass('selected', !isMenuOpen);
    container.toggle(!isMenuOpen);
    $('.level-1').toggle(!isMenuOpen);
    $('.menu-s').toggleClass('selected', !isMenuOpen);
    $('.bar').toggleClass('x', !isMenuOpen);
    $('#page-content, footer').css({'opacity': isMenuOpen ? '1' : '0.5', 'transition': 'opacity 1.25s' });
    }
    e.stopPropagation();
  });

// close menu by clicking anywhere except the menu
  $('body *').not('.flyout *, button.menu-t *').on('click', function(e) {
    var container = $(this);
    var button = $('.menu-s');
    if (container.is(e.target) && container.has(e.target).length === 0 && !button.is(e.target)) {
      $('.menu-container').removeClass('selected').hide();
      $('.menu-s').removeClass('selected');
      $('.bar').removeClass('x');
      $('#page-content, footer').css({'opacity': '1', 'transition': 'opacity 1.25s'});
    }
  });

// footer

  $(document).on('click touchend', 'ul.footer-cols > li a.head', '.inline-arrow', function(e) {
      e.preventDefault();
      $(this).find('.inline-arrow').toggleClass('rotate');
      var ul = $(this).parent().children('ul.footer-col');
      if ($(window).width() < 768) {
        if (ul.css('display') == 'none') {
          ul.css({'display': 'flex', 'flex-direction': 'column'});
        } else {
          ul.css('display', 'none');
        }
      }
  })

  /*
  //reset footer display on resize
  function adjustDisplay() {
    var windowWidth = $(window).width();
    if (windowWidth > 767) {
        $('.footer-cols > li ul').css({'display': 'flex', 'flex-direction': 'column'});
    } else {
        $('.footer-cols > li ul').css('display', 'none');
    }
  }

  $(window).resize(function(){
    adjustDisplay();
  });
*/
}); // end document ready

  /* ------------------------------------------- */
  
  $( ".form-control" ).focus(function() {
      $(this).closest('.form-group').removeClass('focused').addClass('focused');
  });

  $( ".form-control" ).blur(function() {
      if ( $(this).val().length > 0 ) {
          $(this).closest('.form-group').removeClass('focused').addClass('focused');
      } else {
          $(this).closest('.form-group').removeClass('focused');
      }
  });
  
  /**** Hubspot Form Fields - Add/remove "focus" class for inputs and labels ****/
$( "body" ).on('focus', '.hs-form .hs-input', function() {
    if (!$(this).closest('.hs-form-field').hasClass('hs_purchase_reason_or_occasion')) {
        $(this).closest('.hs-form-field').removeClass('focused').addClass('focused');
    }
});

$( "body" ).on('blur', '.hs-form .hs-input', function() {
    var $formField = $(this).closest('.hs-form-field');
    if (!$formField.hasClass('hs_purchase_reason_or_occasion')) {
        if ($(this).val().length > 0) {
            $formField.removeClass('focused').addClass('focused');
        } else {
            $formField.removeClass('focused');
        }
    } else {
        if ($(this).val().length === 0) {
            $formField.removeClass('focused');
        }
    }
});
  
  /** Activate Account Form */
  $( "body" ).on('focus','.active-account-form input',function() {
      $(this).closest('.active-account-form .field ').removeClass('focused').addClass('focused');
  });

  $( "body" ).on('blur','.active-account-form input',function() {
      if ( $(this).val().length > 0 ) {
          $(this).closest('.active-account-form .field').removeClass('focused').addClass('focused');
      } else {
          $(this).closest('.active-account-form .field').removeClass('focused');
      }
  });
  
  $("input.form-control").bind('focus', function() {
     $(this).css('background-color', 'white');
  });
  
  $('.readMore').click(function() {
      var $this = $(this);
      $this.toggleClass('readMore');
      if ($this.hasClass('readMore')) {
        $this.text('Read More');
      } else {
        $this.text('Read Less');
      }
  });
  
  $(document).on('click', '#close-preview', function() {
      $('.image-preview').popover('hide');
      // Hover befor close the preview
      $('.image-preview').hover(
          function () {
             $('.image-preview').popover('show');
          },
           function () {
             $('.image-preview').popover('hide');
          }
      );
  });
  
  // Clear event
  $('body').on('click','.image-preview-clear', function() {
      var $el = $(this);
      $el.closest('.fu_render').find('.image-show').hide();
      $el.closest('.fu_render').find('.uplodedLogo').hide();
      //$('.image-show #dynamic').remove();
      $el.closest('.fu_render').find('.imageTitle').hide();
      $el.closest('.fu_render').find('.image-preview-filename').val("");
      $el.closest('.fu_render').find('.image-preview-clear').hide();
      $el.closest('.fu_render').find('.image-preview-input input:file').val("");
      $el.closest('.fu_render').find(".image-preview-input-title").text(" Browse");
  });
  
  // Create the preview image
  $('body').on('change','.image-preview-input input:file',function(){
      var img = $('<img/>', { id: 'dynamic' });
      var $el = $(this);
      var file = this.files[0];
      var reader = new FileReader();
      // Set preview image into the popover data-content
      reader.onload = function (e) {
          $el.closest('.fu_render').find('.image-show').show();
          $el.closest('.fu_render').find('.uplodedLogo ').show();
          $el.closest('.fu_render').find(".image-preview-input-title").text(" Change");
          $el.closest('.fu_render').find(".image-preview-clear").show();
          $el.closest('.fu_render').find(".image-preview-filename").val(file.name);
          $el.closest('.fu_render').find(".imageTitle").show().text($(".image-preview-filename").val());
          img.attr('src', e.target.result);
          $el.closest('.fu_render').find('.image-show').show();
          $el.closest('.fu_render').find('.image-show').html($(img)[0].outerHTML);
      }
      reader.readAsDataURL(file);
  });
  
  $('.mobileProductTitle').html($('.productTitle').html());
  $('.mobileProductPrice').html($('.productPriceValue').html());

  // moved into FAQ page template in shopify as scrolltop was interfering with other scroll events
/* FAQ Anchor links open on page load */
/*
$(window).load( function() {
  var clean_url = window.location.href.substring(0,window.location.href.indexOf("#"));
  var hash = window.location.hash;
  var msgid = $('.msg_head a[id*="'+hash.substring(1)+'"]');
  if (hash) {
    msgid.click(); 
    $(msgid).scrollTop(msgid.parent().next(".msg_body").offset().top-150);
    msgid.parent().next(".msg_body").slideToggle();
    msgid.addClass("active");
  }

  $('.msg_head a').on('click',function (){
    var anch = $(this).attr('id');
    $(this).parent().next(".msg_body").slideToggle();
    window.location.replace(clean_url + '#' + anch);
    $(msgid).scrollTop($(this).parents(".faqList").siblings(".faqList").offset().top-150);
    if (hash && msgid.hasClass("active")) {
      msgid.toggleClass("active");
    }
    $(this).toggleClass("active");
    $(this).parents(".faqList").siblings(".faqList").find(".msg_head a").removeClass("active");
    $(this).parents(".faqList").siblings(".faqList").find(".msg_body:visible").slideToggle();
  });
})
*/

/* back to top */
const showOn = 500;
const backToTopButton = document.querySelector(".back-to-top");
const scrollContainer = () => {
  return document.documentElement || document.body;
};

  document.addEventListener("scroll", () => {
    if (scrollContainer().scrollTop > showOn) {
      backToTopButton.classList.remove("hidden");
    } else {
      backToTopButton.classList.add("hidden");
    }
  });


const goToTop = () => {
  document.body.scrollIntoView({
    behavior: "smooth",
  });
};

backToTopButton.addEventListener("click", goToTop);
/* --------------------------------- */

/* ------- sticky navbar ------- */

$(window).on('scroll', function() { 
  // Make sticky on desktop only
  if (window.innerWidth > 1024) {
    var navbar = $('.header'); 
    var topBar = $('.top-bar');
    var winWidth = $(window).width();
    var scrollPos = (winWidth <= 600) ? 174 : 163;
    if (!$('.menu-container').hasClass('selected')) {
      if ($(this).scrollTop() > 0 && navbar.css('position') != 'fixed' && topBar.css('position') != 'fixed') { 
        // page was scrolled
        if ( topBar.is(':visible')) {
          topBar.css({'position': 'fixed', 'top': '0', 'left': '0', 'width': '100%', 'z-index': '1001'}); 
          navbar.css({'position': 'fixed', 'top': '48px', 'left': '0', 'z-index': '1001'}); 
        } else {
          navbar.css({'position': 'fixed', 'top': '0', 'left': '0', 'z-index': '1001'}); 
        }
      }
    }
    if ($(this).scrollTop() == 0 && navbar.css('position') == 'fixed' ) {
      // page is on top
      if ($('.rep-header').is(':visible')) {
        navbar.css({'position': 'relative', 'top': '0', 'z-index': '999'});
      } else {
        topBar.css({'position': 'relative', 'top': '0', 'z-index': '999'});
        navbar.css({'position': 'relative', 'top': '0', 'z-index': '999'});
      }
    } 
  }
});

    
  $('body').addClass('secLoading');

  $('.account-box').addClass('scaleOnHover');

  if (typeof($.fn.tooltip) != 'undefined') {
    if ($('html').hasClass('touch')) {
      $('[data-toggle="tooltip"]').tooltip();
    } else {
      // On hard goods pdp, remove delay from tooltip
      if ($('.hg-container').length) {
        console.log("HARD GOODS")
        $('[data-toggle="tooltip"]').tooltip();
      } else {
        console.log("NOT HARD GOODS")
        // delayToolTip();
        $('[data-toggle="tooltip"]').tooltip({ delay: { show: 50,  hide: 300 }});
      }
    }
  }
    
  $(".numbers-row").append('<span class="inc button buttnQtyChange arrow_triangle-up"></span><span class="dec button buttnQtyChange arrow_triangle-down"></span>');
  




 //PDP Qty inputs
  const origar = Array.from($('.InStockText')).map(t => t.innerText).map(Number);
  if (origar.length > 0 ) {
  }
  $("body").on("click",".buttnQtyChange", function () {
      let newVal = 0;
      let newinstockval = 0;
      var $button = $(this);
      var oldValue = $button.parent().find("input").val() * 1;
      var instock = $(this).parents().next('div.instock:not(.outOfStock)');
      var casePackQty = $(this).parent().find(('input[name="smallQty"]')).data('case-pack');
      var oldinstocktext = instock.text();
      var oldinstockval = parseInt(oldinstocktext) * 1;
      if( $(this).closest('.ProductSizeInfo').length > 0 ) {
        $(this).parent().find("input").trigger('input');
        // Product Page
        if (!$(this).parents('.ProductSizeInfo').hasClass('outOfStock')) {
          if ($button.hasClass('inc')) {
            $(this).parents('.ProductSizeInfo').addClass('selected');
            var idx = $(this).prev($('input[name="smallQty"]')).attr('id').slice(-1);
            if (isSampleOrder && parseInt(oldValue) > 0) {
              newVal = oldValue;
            } else {
              if ( parseInt(instock.text()) <= 1 ) {
                $('.needmore').show();
              }
              if ( parseInt(instock.text()) == 0 ) { 
                newVal = origar[idx];
                instock.text('0');
              } else {
                newVal = parseInt(oldValue) + 1;
                newinstockval = parseInt(oldinstockval) - 1;
                instock.text(newinstockval);
              }
            }  
          } else {
            /** Don't allow decrementing below zero **/
            if (oldValue >= 1) {
              $('.needmore').hide();
              newVal = parseInt(oldValue) - 1;
              newinstockval = parseInt(oldinstockval) + 1;
              instock.text(newinstockval);
            } else {
              newVal = 0;
              $(this).parents('.ProductSizeInfo').removeClass('selected');
            }
          }
        }
        $button.parent().find("input").val(newVal); 
      } else {
        // Cart Page
        if ($button.hasClass('inc')) {
          newVal = parseInt(oldValue) + 1;
        } else {
          /** Don't allow decrementing below zero **/
          if (oldValue > 1) {
            newVal = parseInt(oldValue) - 1;
          } else {
            newVal = 0;
          }
        }
        $button.parent().find("input").val(newVal);
      }
  });


// --------------------------------

  if (typeof($.fn.hasExtension) == 'undefined') { 
    $.fn.hasExtension = function(exts) {
        return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', 'ig')).test($(this).val());
    }
  }
  
  $(window).trigger('resize');
  
  $('body').on('click','.ProductSizeText .icon_circle-empty,.ProductSizeText .size-lable',function() {
    var sel = $(this).parents('.ProductSizeInfo');
    var idx = $(sel).first().index()-2;
    if ( !$(this).closest('.ProductSizeInfo').hasClass('selected') && !$(this).closest('.ProductSizeInfo').hasClass('outOfStock') ) {
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').trigger('input');
        $(this).closest('.ProductSizeInfo').addClass('selected');
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').val(1);
        var instock = $(this).closest('.ProductSizeInfo').find('.instock');
        instock.text(parseInt(instock.text())-1);
        if ( parseInt(instock.text()) < 1 ) {
          $('.needmore').show();
        }
    } else if( $(this).closest('.ProductSizeInfo').hasClass('selected') && !$(this).closest('.ProductSizeInfo').hasClass('outOfStock') ) {
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').trigger('input');
        $(this).closest('.ProductSizeInfo').removeClass('selected');
        $(this).closest('.ProductSizeInfo').removeClass('quantity-more-than-max');
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').val(0);
        var instock = $(this).closest('.ProductSizeInfo').find('.instock');
        instock.text(parseInt(origar[idx]));
        $('.needmore').hide(); 
        
      }
  });
  
  function checkForMaxQuantity($input) {
    var $thisInputVal = $input.val();
    var $thisInputMax = $input.attr('max');
    if ( !isNaN($thisInputVal) && !isNaN($thisInputMax) ) {
      if( $thisInputVal < $thisInputMax ) {
        $input.closest('.ProductSizeInfo').removeClass('quantity-more-than-max');
      }
    }
  }

  function updatePDPTotalQuantity() {
    var totalQty = 0;
    $('.applyDiscOnChange').each(function() {
      if (!isNaN(parseInt($(this).val()))) {
        totalQty += parseInt($(this).val());
      }
    });
    const pdpTotalQty = $('.product-select-label-total-value');
    if (pdpTotalQty.length > 0) {
      pdpTotalQty.text(totalQty);
    }
  }

  
  $('.applyDiscOnChange').bind('input',function() {
        var $tempThis = $(this);
        checkForMaxQuantity($tempThis);
        setTimeout(function() {
            updatePDPTotalQuantity();
            if ( typeof changePrice != "undefined" )
            changePrice('change');
            if ( $tempThis.val() != "" && $tempThis.val() != "0" ) {
                if ( !$tempThis.closest('.ProductSizeInfo').hasClass('selected') && !$tempThis.closest('.ProductSizeInfo').hasClass('outOfStock') ) {
                    $tempThis.closest('.ProductSizeInfo').addClass('selected');
                }
            } else {
                $tempThis.closest('.ProductSizeInfo').removeClass('selected');
            }
        },20);

  });
  
  $('.applyDiscOnChange').bind('focus',function() {
      if ( $(this).val() == "0" ) {
        $(this).val('');
      }
  });
  
  $('.applyDiscOnChange').bind('blur',function() {
      if( $(this).val() == "" ) {
        $(this).val('0');
      }
  });
  
  //merchPerks product restriction to 1 quantity only
  $('.merchperk-prod-inp').bind('input',function() {
      setTimeout(function() {
            var tempTotalQty = 0;
            $('.merchperk-prod-inp').each(function() {
              if (!isNaN(parseInt($(this).val()))) {
                tempTotalQty = tempTotalQty + parseInt($(this).val());
              }
            });

            if (tempTotalQty > 1) {
              $('.CartBtnSec .addToCart').attr('disabled','disabled').addClass('merchperk-error');
              if ($('.product-select-size-upper .addToCart')) {
                $('.product-select-size-upper .addToCart').attr('disabled','disabled').addClass('merchperk-error')
              }
              $('.CartBtnSec .error').addClass('merchperk-error').html('You can only add one MerchPerk to each order.<br> Please adjust your selected quantity to continue.').show();
            } else {
              if ($('.CartBtnSec .addToCart').hasClass('merchperk-error')) {
                  $('.CartBtnSec .addToCart').removeAttr('disabled').removeClass('merchperk-error');
              }
              if ($('.product-select-size-upper .addToCart')) {
                if ($('.product-select-size-upper .addToCart').hasClass('merchperk-error')) {
                  $('.product-select-size-upper .addToCart').removeAttr('disabled').removeClass('merchperk-error');
                }
              }
              if ($('.CartBtnSec .error').hasClass('merchperk-error')) {
                  $('.CartBtnSec .error').html('').hide().removeClass('merchperk-error');
              }
            }
      },30);

  });

  // When user clicks the "Details" link on the DESKTOP product page, scroll to the DETAILS tab and open it
  $('body').on('click', '.show-product-details-tab', function() {
    $('html,body').animate({
      scrollTop: eval($('.productTabs .nav-tabs').offset().top-10)
    }, 1000);
    $('a[aria-controls="details"]').trigger('click');
  });
  
    
  //footer autocomplete position set    
  setTimeout(function(){ setFooterAutoPos(); }, 1000);
  $( ".form-sec-footer .ui-autocomplete-input:first" ).change(function(){
    setFooterAutoPos();
  });
  
  $(window).resize(function() {
    setTimeout(function(){ setFooterAutoPos(); }, 100);
  });
  
  var inputText = $( "input,textarea" );
  inputText.each(function() {
    if($(this).val().length != 0 ) {
      $(this).parents().addClass('focused');
    }
  });
  
  $('body').on('click','.product-adjust-maximum-quantity',function() {
    var totalNumOfVariants = $('#variant-size').val() * 1;
    for (i =0; i <= totalNumOfVariants; i++) {
      var variant_qty = $("#quantity-"+i).val() * 1;
      var variant_qty_max = $("#variant-max-"+i).val() * 1;
      if ( !isNaN(variant_qty) && !isNaN(variant_qty_max) ) {
        if ( variant_qty > variant_qty_max ) {
          $("#quantity-"+i).val(variant_qty_max);
          $("#quantity-"+i).closest('.ProductSizeInfo').removeClass('quantity-more-than-max');
        }
      }
    }
    $('.CartBtnSec p.error').html('').hide();
    $('.CartBtnSec p.success').html('Quantities automatically adjusted! Click the Add to Cart button above to continue with your order.').show();
    changePrice(); // this function is in price-script.liquid
    $('.addToCart').attr('disabled',false); // renable the Add to Cart button
    checkIfMinimumQuantityAchieved();
  });
  
    //product detail accordion options
    $('.accord-head').on('click', function(event) {
          event.preventDefault();
  
          if($(this).hasClass('accord-disabled')) {
            return false;
          }
          // create accordion variables
          var accordion = $(this);
          var accordionContent = accordion.next('.accord-content');
  
          // toggle accordion link open class
          if (accordion.hasClass("open")) {
              accordion.removeClass("open");
          } else {
            accordion.addClass("open");
          }
  
          // toggle accordion content
          accordionContent.slideToggle(500);
  
     });
    $('.shappify_option_value input[type=radio]').on('change', function() {

      $(this).closest('.shappify_option_value').find('[name="'+ this.name +'"]').each(function(index, item) {
        $(item).parent().removeClass('radioClicked');
      })
      $(this).parent().addClass('radioClicked');

      if ((this.name === 'properties[_Add second logo ?]') &&
      !($('[name="properties[_Second logo decoration type]"]:checked').parent().hasClass('radioClicked'))) {
        $('[name="properties[_Second logo decoration type]"]:checked').parent().addClass('radioClicked');
      }
    });

    $('.customize-accord  input[type=checkbox]').on('change',function() {
        if ($(this).is(":checked")) {
          $(this).closest('.shappify_checkbox_option').addClass('checkboxClicked');
        } else {
          $(this).closest('.shappify_checkbox_option').removeClass('checkboxClicked');
        }
    });
  
    $('.customize-accord  input[type=number], .customize-accord  input[type=text]').on('change',function() {
        if ($(this).val() != '' && $(this).val() != '0') {
          $(this).closest('.shappify_input_option').addClass('inputClicked');
        } else {
          $(this).closest('.shappify_input_option').removeClass('inputClicked');
        }
    });

    // Handle keyboard quantities value changes
    $('input[name="smallQty"]').on('change', function(event) {
      if(isSampleOrder) {
        const newValue = $(this).val();
        if (newValue > 1) {
          $(this).val(1);
        }
      }
    });
  
     // Handle user changes to decoration type
     $('input[name="properties[_Decoration type]"]').on('change', function(event) {
        if ($('input[name="properties[_Decoration type]"]:checked').length > 0 && $('input[name="properties[_Decoration type]"]:checked').val() != 'Sample') {
            // User selected a decoration type other than "Sample"
            setSampleOrder(false);

            // Automatically select the first decoration location
            $('input[name="properties[_Select decoration location]"]:first').prop('checked','checked').trigger('change');

            // Open and enable the section 02 CHOOSE DECORATION LOCATION
            if ($('.hg-container').length) {
              $('.accord-sr-2, .accord-sr-3, .accord-sr-4').removeClass('option-disabled');
              $('.accord-sr-2, .accord-sr-3, .accord-sr-4').find('.shappify_option_value').slideDown(500);
            } else {
              $('.accord-sr-2 .accord-head').next('.accord-content').slideDown(500);
              $('.accord-sr-2 .accord-head').removeClass('accord-disabled').addClass('open');
              $('.accord-sr-4 .accord-head').removeClass('accord-disabled'); // Enable section 04 OPTIONAL EXTRAS
            }

            if ($('input[name="properties[_Decoration type]"]:checked').val() == 'Embroidered') {
              $('[name="properties[_Second logo decoration type]"]').attr('disabled', 'true');
              $('#add_color').slideUp(500);
            } else {
              $('[name="properties[_Second logo decoration type]"]').removeAttr('disabled');
              $('#add_color').slideDown(500);
            }
  
        } else {
            // User selected "Sample" for decoration type, so hide decoration location, and optional extras sections, show choose logo
            setSampleOrder(true);

            if ($('.hg-container').length) {
              $('.accord-sr-2, .accord-sr-3, .accord-sr-4').addClass('option-disabled');
              $('.accord-sr-2, .accord-sr-3, .accord-sr-4').find('.shappify_option_value').slideUp(500);
              resetRadioSec($('.accord-sr-2').find('.shappify_option_value'));
            } else {
              $('.accord-sr-2 .accord-head').next('.accord-content').slideUp(500);
              $('.accord-sr-2 .accord-head').addClass('accord-disabled').removeClass('open');

              // close Choose Your Logo section for sample
              $('.accord-sr-3 .accord-head').next('.accord-content').slideUp(500); 
              $('.accord-sr-3 .accord-head').removeClass('open').addClass('accord-disabled');

              $('.accord-sr-4 .accord-head').next('.accord-content').slideUp(500);
              $('.accord-sr-4 .accord-head').addClass('accord-disabled').removeClass('open');
    
              //if ($('input[name="properties[_Select decoration location]"]:checked').length) {
              //  $('input[name="properties[_Select decoration location]"]:checked').removeAttr('checked').trigger('change');
              //}
              resetRadioSec($('.accord-sr-2 .accord-head').next('.accord-content'));
            }
        }
     });
  
      // Handle user changes to decoration location
      $('input[name="properties[_Select decoration location]"]').on('change', function(event) {
  
        if ($('input[name="properties[_Select decoration location]"]:checked').length > 0) {
              // There is a decoration location selected
              if ($('.first_logo input[name="properties[_Add embroidered logo ?]"][data-checked="checked"]').length > 0) {
                // Switch the logo option to the same value of the last item added to the cart
                $('.first_logo input[name="properties[_Add embroidered logo ?]"][data-checked="checked"]').prop('checked','checked').trigger('change');
              } else {
                // Default to the first logo option
                $('.first_logo input[name="properties[_Add embroidered logo ?]"]:first').prop('checked','checked').trigger('change');
              }

              // Open and enable section 03 CHOOSE YOUR LOGO (keep hidden for Sample orders)
              if (!isSampleOrder) {
                $('.accord-sr-3 .accord-head').next('.accord-content').slideDown(500);
                $('.accord-sr-3 .accord-head').removeClass('accord-disabled').addClass('open');
              }
  
        } else {
              // No decoration location selected
              // Close and disable section 03 CHOOSE YOUR LOGO
              $('.accord-sr-3 .accord-head').next('.accord-content').slideUp(500);
              $('.accord-sr-3 .accord-head').addClass('accord-disabled').removeClass('open');
  
              if ($('.first_logo input[name="properties[_Add embroidered logo ?]"]:checked').length) {
                // Remove the selected logo option
                var checkedAddLogo  = $('.first_logo input[name="properties[_Add embroidered logo ?]"]:checked');
                checkedAddLogo.removeAttr('checked');
              }
  
              resetRadioSec($('.accord-sr-3 .accord-head').next('.accord-content'));
        }
     });

  
    $('.first_logo input[name="properties[_Add embroidered logo ?]"]').on('change', function(event){
        if ($('.first_logo input[name="properties[_Add embroidered logo ?]"]:checked').length && $('.first_logo input[name="properties[_Add embroidered logo ?]"]:checked').val() == 'Yes') {
              showLogoUploadFile(true);
  
        } else if (this.className.indexOf("second_logo_on_file") === -1 && this.className.indexOf("add_second_logo_later") === -1 ) {
             showLogoUploadFile(false);
        }
     });
  
  $('input[type="file"][name="properties[_Upload your logo (2MB max)]"]').on('change', function(event) {
      
      setPreviewUploadImage(this);
  });
  
  $('.main-uploadlogo-container .uploaded-img-editlink').on('click',function() {
    clearInput();
    showLogoFileBrowse();
  })
  
  $('.main-uploadlogo-container .upload-img-cancel-edit').on('click',function() {
    cancelEditUploadImg();
  })
  
     $('.js-add-second-logo').on('change', function(event) {
       
        if ($(this).is(":checked")) {
            $('.second-logo-container').slideDown(500);
            if ($('.second_logo_upload:checked').length > 0) {
              $('.second_logo_upload').prop('checked','checked').trigger('change');
            }
            if ($('.second_logo_upload:checked').length < 1) {
             $('.second_logo_upload').prop("checked",true).trigger("change"); 
            }
        } else {
            $('.second-logo-container').slideUp(500);
            if($('.second_logo_upload:checked').length){
              var checkedSecondAddLogo  = $('.second_logo_upload:checked');
                checkedSecondAddLogo.removeAttr('checked');
                checkedSecondAddLogo.trigger('change');
            }
          }
     });
    
  $('.second_logo_upload').on('change', function(event) {
      if ($('.second_logo_upload:checked').length>0 && $('.second_logo_upload:checked').val() == 'Yes') {
          add_showLogoUploadFile(true);
      } else {
          add_showLogoUploadFile(false);
      }  
  });
      
      $('.second_logo_on_file').on('change', function(event) {
          add_showLogoUploadFile(false);
      });
      $('.add_second_logo_later').on('change', function(event) {
          add_showLogoUploadFile(false);
      });
      $('input[type="file"][name="properties[_Upload second logo]"]').on('change', function(event) {
          add_setPreviewUploadImage(this);
      });
      $('.additional-uploadlogo-container .uploaded-img-editlink').on('click',function(){
          add_showLogoFileBrowse();
      })
      $('.additional-uploadlogo-container .upload-img-cancel-edit').on('click',function(){
          add_cancelEditUploadImg();
      })

    selectDefaultDecoType();
    selectDefaultSizeForGoogle();
  
    // Registration Empty Field Check
  $('form#create_customer').submit(function(){
    var regFirstName = $(this).find("input[name='customer[first_name]']").val();
    var regLastName = $(this).find("input[name='customer[last_name]']").val();
    var regCompany = $(this).find("input[name='customer[note][Company]']").val();
    var regEmail = $(this).find("input[name='customer[email]']").val();
    var regPassword = $(this).find("input[name='customer[password]']").val();
    var regErrorFlag = 0;
  
    if ( regFirstName.isEmpty() ) {
      regErrorFlag = 1;
      $(this).find("input[name='customer[first_name]']").closest('.form-group').addClass('form-has-error');
    } else
      $(this).find("input[name='customer[first_name]']").closest('.form-group').removeClass('form-has-error');
  
    if ( regLastName.isEmpty() ) {
      regErrorFlag = 1;
      $(this).find("input[name='customer[last_name]']").closest('.form-group').addClass('form-has-error');
    } else
      $(this).find("input[name='customer[last_name]']").closest('.form-group').removeClass('form-has-error');
  
    if ( regEmail.isEmpty() ) {
      regErrorFlag = 1;
      $(this).find("input[name='customer[email]']").closest('.form-group').addClass('form-has-error');
    } else
      $(this).find("input[name='customer[email]']").closest('.form-group').removeClass('form-has-error');
  
    if ( regPassword.isEmpty() ) {
      regErrorFlag = 1;
      $(this).find("input[name='customer[password]']").closest('.form-group').addClass('form-has-error');
    } else
      $(this).find("input[name='customer[password]']").closest('.form-group').removeClass('form-has-error');
  
    if( regErrorFlag == 1 ) return false;
  });
  
  // Register form : On change error add or remove
  $('body').on('keyup keydown','form#create_customer input',function() {
    var $input = $(this);
    if ($input.attr('id') === 'Email') {
      var $emailInput = $('#gtm_create_account_email');
      $emailInput.val($input.val());
    }
    setTimeout(function(){
        if ( $input.attr('name') != "customer[note][Company]" ) {
          if ( $input.val().isEmpty() ) {
              $input.closest('.form-group').addClass('form-has-error');
          } else {
              $input.closest('.form-group').removeClass('form-has-error');
          }
        }
      },200);
  });
  
  // Phone number validation for special characters and other chratacters ( Contact Us Page )
  $("body").on('keydown',"input[name='phone']",function (e) {
      // Allow: backspace, delete, tab, escape, enter and plus sign .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190, 107]) !== -1 ||
           // Allow: Ctrl+A, Command+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
           // Allow: home, end, left, right, down, up
          (e.keyCode >= 35 && e.keyCode <= 40)) {
               // let it happen, don't do anything
               return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
      }
  });
  
  // Remove checked checkbox and image field on product optional extras
  $('body').on('click','input[name="properties[_Decoration type]"]',function(){
    if( $(this).attr('value') == "Sample" ) {
          $('input[type="file"][name="properties[_Upload second logo]"]').val('');
          $('form#bold-form-options div.customize-accord:last input[type=checkbox]').each(function(){
              var $thisCheckbox = $(this);
              if( $thisCheckbox.closest('.shappify_checkbox_option').hasClass('checkboxClicked') )
                  $thisCheckbox.closest('.shappify_checkbox_option').trigger('click');
          });
    }
  });
  selectDefaultLogoOption();
});

// Save url to cookie on click
$('.product-upload-logo').click(function() {
  createCookie('product_url_for_logo', $(this).attr('data-save'), 1);
  createCookie('product_logo_replacement', $(this).attr('data-logo-placement'), 1);
});

function initSlick() {
  var heroSlider = $('.heroSlider');
  if (heroSlider.length > 0) {
      heroSlider.slick({
        prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
        swipeToSlide: true,
        dots: true,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
        adaptiveHeight: false,
        cssEase: "ease-in-out",
        useTransform: true
      });
  }

  var resSlider = $('.resSlider');
  if (resSlider.length > 0) {
    resSlider.slick({
      prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
      nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
      swipeToSlide: true,
      dots: true,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 5000,
      adaptiveHeight: false,
      useAutoplayToggleButton: false,
      cssEase: "cubic-bezier(0.55, 0.055, 0.675, 0.19)"
    });
}

  var logoSlider = $('.logoSlider');
  if (logoSlider.length > 0) {
    logoSlider.slick({
      prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
      nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
      swipeToSlide: true,
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: true,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 4000,
      adaptiveHeight: false,
      cssEase: "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
      responsive: [
        {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
      ]
    });
}
  var blogSlider = $('.blogSlider');
  if (blogSlider.length > 0) {
    blogSlider.slick({
      prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
      nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
      swipeToSlide: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 4000,
      adaptiveHeight: false,
      cssEase: "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
      responsive: [
        {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
      ]
    });
}

  var heroSliderUA = $('.heroSlider-ua');
  if (heroSliderUA.length > 0) {
      heroSliderUA.slick({
          prevArrow: false,
          nextArrow: false,
          swipeToSlide: false,
          dots: false,
          autoplay: false,
          infinite: false,
          autoplaySpeed: 3000,
          adaptiveHeight: true,
          touchMove: false,
          swipe: false
      });
  }

  var offerSlider = $('.offerSlider');
  if (offerSlider.length > 0) {
      offerSlider.slick({
          dots: false,
          infinite: false,
          swipeToSlide: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
          nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
          responsive: [
              {
                  breakpoint: 767,
                  swipeToSlide: true,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                  }
              }

          ]
      });
  }

  var colorChoiceSlider = $('.colorChoiceSlider');
  if (colorChoiceSlider.length > 0) {
      colorChoiceSlider.slick({
          slidesToShow: 7,
          slidesToScroll: 7,
          speed: 200,
          swipeToSlide: false,
          infinite:false,
          prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
          nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
          responsive: [
              {
                  breakpoint: 767,
                  settings: {
                      swipeToSlide: false,
                      arrows:false,
                      slidesToShow: 6,
                      slidesToScroll: 6
                  }
              }

          ]
      });
  }

  var colorChoiceSliderColl = $('.colorChoiceSlider-coll')
    if (colorChoiceSliderColl.length > 0) {
      try {
      colorChoiceSliderColl.slick({
        slidesToShow: 7,
        slidesToScroll: 6,
        speed: 500,
        infinite: false,
        arrows: true,
        cssEase: 'ease-in-out',
        prevArrow: "<span class='arrow_carrot-left coll-prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right coll-nextArrow'></span>",
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    swipeToSlide: true,
                    slidesToShow: 4,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                  swipeToSlide: true,
                  slidesToShow: 4,
                  slidesToScroll: 3
                }
            }
        ]
      });
      } catch (e) { if (window.console) console.warn('colorChoiceSlider-coll slick init skipped:', e); }
  }

  var productSlider = $('.product');
  if (productSlider.length > 0) {
      productSlider.slick({
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        //fade: true,
        prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
        asNavFor: '.product-nav'
      });
  }

  var navSlider = $('.navSlider');
    if (navSlider.length > 0) {
      navSlider.slick({
        swipeToSlide: false,
        slidesToShow: 1,
        autoplay: true,
        infinite: true,
        speed: 1000,
        autoplaySpeed: 3000,
        lazyLoad: 'ondemand',
        slidesToScroll: 1,
        dots: true,
        pauseOnHover: false,
        arrows: false,
        responsive: [
        {
        breakpoint: 767,
          settings: {
            swipeToSlide: true,
            arrows:false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
       }
      ]
    });

      navSlider.on('click', function(e) {
        e.stopPropagation();
      });
  }

  var productNavSlider = $('.product-nav');
  if (productNavSlider.length > 0) {
    productNavSlider.slick({
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product',
      dots: false,
      arrows: false,
      prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
      nextArrow: "<span class='arrow_carrot-right nextArrow'></span>"
    });

    $('body').on('click', '.product-nav .slick-slide', function (evt) {
      const slideNumber = $(evt.target).parents('.slick-slide').attr('data-slick-index');
      $('.product-nav').slick('slickGoTo', slideNumber);
    });
  }
} //END function initSlick()

// This function will open a modal on any page by simply including the modal's ID in the "show_modal" URL parameter
// For example, "?show_modal=getLogoMockupModal" would open the modal with id="getLogoMockupModal"
// @Noerbot5000
function openModalFromUrlParameter() {
  if(getParameterByName("show_modal") != ''){
    var modalToOpen =  "#" + getParameterByName("show_modal");
    $(modalToOpen).modal('show');
  }
}

function getFocus() {
    document.getElementById("footer-search-textinput").focus();
}
// Subscribe MailChimp

$.fn.hasExtension = function(exts) {
    return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', 'ig')).test($(this).val());
}

function validateEmailMC(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

String.prototype.isEmpty = function() {
    return (this.length === 0 || !this.trim());
};

function subscribeMC() {
  //return false;
 var subEmailMC = $('#subscribeMailChimpExclusive').val();

 $('.subscribeMailChimpErr').html('');
 if( validateEmailMC(subEmailMC) )
 {
   $('.subscribeMailChimpLoader').show();
   $.ajax({
     type: 'POST',
     url: 'https://rangempls.com/merchology/subscribe.php',
     data: {'MERGE0':  subEmailMC },
     success: function(data) {
       $('.subscribeMailChimpLoader').hide();
       $('#subscribeMailChimpExclusive').val('');
       $('.subscribeMailChimpErr').html(data);
     },
     error: function(XMLHttpRequest, textStatus) {
       $('.subscribeMailChimpLoader').hide();
       $('.subscribeMailChimpErr').html('<p class="error">Something is wrong.Please try again!</p>');
     }
   });
 }
 else
 {
   $('.subscribeMailChimpErr').html('<p class="error">Please enter valid email address!</p>');
 }
}


/* Create Cookie - this function can be used to create a cookie! */
function createCookie(name, value, days) {
    var date, expires;
    if (days) {
        date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

function share_fb(url) {
  window.open('https://www.facebook.com/sharer/sharer.php?u='+url,'facebook-share-dialog',"width=626,height=436")
}

function equalheight(container) {
    var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el;
     
    $(container).each(function() {

       $el = $(this);
       $($el).height('auto');
       var topPosition = $el.position().top;

       if (currentRowStart != topPosition) {
         for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
           rowDivs[currentDiv].height(currentTallest);
         }
         rowDivs.length = 0; // empty the array
         currentRowStart = topPosition;
         currentTallest = $el.height();
         rowDivs.push($el);
       } else {
         rowDivs.push($el);
         currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
       }
       
       for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
         rowDivs[currentDiv].height(currentTallest);
       }

    });
}

function hardEqualHeights(container){
  var max_height = 0;
    $(container).height('auto');
  $(container).each(function(){
    max_height = Math.max($(this).height(), max_height);
  });
  $(container).each(function(){
    $(this).height(max_height);
  });
}

function countHeights() {
  winHeight = $(window).height();
  winWidth = $(window).width();
}

var shortHeight = function() {
    countHeights();
    //$('#sort-by-list, .select-attrs').css({'max-height':winHeight-95})
}

var tabHeights = function() {
    countHeights();
    $('#details, #delivery, .productReview ').css({'max-height':winHeight})
}


function setFooterAutoPos () {
  if (typeof $jquery.fn.autocomplete != 'undefined') {
    $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("footer_ui_complete").removeClass("ui_fixed_height");
    $jquery( ".header .ui-autocomplete-input:first" ).autocomplete("widget").addClass("header_ui_complete");

    if($(window).width() < 768) {
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", { my: "left top", at: "left bottom", collision: "none" });
    } else if ($(window).width() >= 768 && $(window).width() < 982) {
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("ui_fixed_height");
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", {my:"right bottom-80",at:"right+80 bottom",collision:"none"});
    } else {
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("ui_fixed_height");
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", {my:"left-25 bottom-80",at:"left bottom",collision:"none"});
    }
  }
}

function checkSurveyFldMakeActiveNext() {
  if ($('.product-survery-hb-form input:visible').length > 0) {
    var inpType = $('.product-survery-hb-form input:visible').attr('type');
    var inpVal = $('.product-survery-hb-form input:visible').val();
    if (inpType == 'email') {
      if ( inpVal != '' && validateEmailMC(inpVal)) {
        $('.product-survey-next').addClass('next-active-state');
      } else {
        $('.product-survey-next').removeClass('next-active-state');
      }
    } else if (inpVal != '') {
      $('.product-survey-next').addClass('next-active-state');
    } else {
      $('.product-survey-next').removeClass('next-active-state');
    }
  } else if ($('.product-survery-hb-form select:visible').length > 0) {
    if ($('.product-survery-hb-form select:visible option:selected').val() != '') {
      $('.product-survey-next').addClass('next-active-state');
    } else {
      $('.product-survey-next').removeClass('next-active-state');
    }
  }
}

  /***** start - product option disable enable accordion ********/
function resetRadioSec(tempSec) {
    tempSec.find('.shappify_radio_option').removeClass('radioClicked');
}

function showLogoUploadFile(flgVal) {

  if (flgVal == true) {
    $('.main-uploadlogo-container').show();
    $('.logo-on-file-selected-container').hide();
  } else {
    $('.main-uploadlogo-container').hide();
  }
}

function showLogoFileBrowse() {
  $('.main-uploadlogo-container').removeClass('photo-exists').show();
}

function cancelEditUploadImg() {
  $('.main-uploadlogo-container').addClass('photo-exists');
}

/** Laser engraved only accept eps, ai, and svg files 
 *  Printed only accept eps, ai, and svg files if Hard Good
 *  Screen Print hard good only accept eps, ai, and svg files
*/

/*-------  Helper functions -------*/

/**
 * clears the file uploader inputs 
 * @returns
 */
function clearInput() {
  // clear input of any previous logo if not allowed or if deco method switched
  // reset the form
  $("input#hidden_upload_your_logo_name").val("");
  $(".main-uploadlogo-container").removeClass("photo-exists").attr('data-photo',false);
  //$(".accord-sr-3 span.uploaded-img-span").html("");
  $("span.uploaded-img-span").html("");
  $("span.uploaded-img-name").html("");
  return;
}

/**
 * sets the alert text and briefly highlights via a background color change to inform the user
 * @param {String} type type of deco method
 * @returns 
 */
function highlightAlert(type){
  $('.allowedFiles').show().html('Allowed '+type+' logo file types for this product are eps, ai, and svg');
  $('.allowedFiles').animate({"background-color": "#ffffff"}).delay(100).animate({"background-color": "#84dade"});
}

/**
 * checks the type of deco method and sets appropriate allowed files
 * @param {String} type type of deco method
 * @returns boolean
 */
function setTypes(type) {
  if ( type == "Sample" ) {
    $('.accord-sr-3 .accord-head').next('.accord-content').slideUp(500);
    $('.accord-sr-3 .accord-head').removeClass('open').addClass('accord-disabled');
    $('.allowedFiles').hide();
  } else if ( type != "Embroidered" ) {
    var laseng = ".eps, .svg, .ai";
    $('.allowedFiles').show().html('Allowed '+type+' logo file types for this product are eps, ai, and svg');
    if (!checkCurrentImageFileType(laseng)){
      $('.allowedFiles').animate({"background-color": "#ffffff"}).delay(100).animate({"background-color": "#84dade"});
      clearInput();
    }
  } else {
    $('.allowedFiles').hide();
    var laseng = ".eps, .ai, .svg, .psd, .jpg, .jpeg, .png, .gif";
    if (!checkCurrentImageFileType(laseng)){
      clearInput();
    }
  }
  
  if (type != "Sample") {
    $("input.cloudinary-fileupload[type=file]").attr("accept", laseng);
    // if logo mockup tool not initialized
    $("#default-logo-upload").attr("accept", laseng);
  }
  return true;
}

function checkCurrentImageFileType(acceptedTypes) {
  var currentImageUrl = $("input#hidden_upload_your_logo_name").val();
  if ( typeof currentImageUrl != "undefined" ) {
    var fileType = currentImageUrl.split(/[#?]/)[0].split('.').pop().trim();
    return acceptedTypes.includes(fileType);
  }
}

/*-------  End helper functions -------*/
// check if embroidered, if not, set laseng to vector

$(document).ready(function() {
  var typeOfDeco= $('label.radioClicked input').val();
  setTypes(typeOfDeco);

  // Set a observer that waits for the previously uploaded image to load and clear input/show error if file type not compatible
  const targetNode = document.getElementById("hidden_upload_your_logo_name");
  if ( targetNode != null ) {
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      if ($("input#hidden_upload_your_logo_name").val()) {
        setTypes(typeOfDeco);
        observer.disconnect();
      }
    }
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  $('input:radio[name="properties[_Decoration type]"]').on('change', function() {
    decoChecked = $('input:radio[name="properties[_Decoration type]"]:checked').val();
    //console.log(decoChecked);
   setTypes(decoChecked);
  }); 
}); 

async function getPreviewForVectorFile(file) {
  const cloudinaryUrl = 'https://api.cloudinary.com/v1_1/merchology/image/upload'; 
  const uploadPreset = 'rnrorcvk';
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);
  try {
    const response = await fetch(cloudinaryUrl, {
      method: 'POST',
      body: formData
    });
    const result = await response.json();
    return result.secure_url;
  } catch (error) {
    console.error('Error uploading image:', error);
    return null;
  }
}

/**
 * sets the preview image for the file chosen and prepares upload to cloudinary
 * @param {Object} input the input object
 */
async function setPreviewUploadImage(input) {
  var typeVal = $('label.radioClicked input').val();
  var ifLas = !$(input).hasExtension(['.eps','.ai','.svg']);
  var appendStr = '<img style="position: absolute; top: 1px; left: 1px;" src="https://cdn.shopify.com/s/files/1/0312/6537/files/disallowed.png?v=1677861932" />';
  if  ( typeVal != "Embroidered" && typeVal != "Sample" && ifLas == true ) {
    $('span.uploaded-img-span').append(appendStr);
    highlightAlert(typeVal);
    $('.addToCart').attr('disabled',true);
  } else if ( typeVal == "Sample" ) {
    $('.accord-sr-3 .accord-head').next('.accord-content').slideUp(500);
    $('.accord-sr-3 .accord-head').removeClass('open').addClass('accord-disabled');
    $('.allowedFiles').hide();
  } else {
    checkIfMinimumQuantityAchieved();
    //$('.addToCart').attr('disabled',false);
    if (typeVal != "Embroidered") {
      $('.allowedFiles').show().html('Allowed '+typeVal+' logo file types for this product are eps, ai, and svg');
    } else {
      $('.allowedFiles').hide();
    }
    $('.uploaded-photo-div #disallowed').remove();
  }
  var preview = document.getElementById('preview_uploaded_file');
  if (input.files && input.files[0]) {
    if(typeof($.fn.hasExtension) == 'undefined') { 
      $.fn.hasExtension = function(exts) {
        return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', 'ig')).test($(this).val());
      }
    }

    if (!$(input).hasExtension(['.jpg','.jpeg','.png','.gif','.eps','.ai','.svg','.psd'])) {
      $('.main-uploadlogo-container').addClass('invalid-file-error');
      $('.upload-logo-invalid-error').show();
    } else {
      $('.upload-logo-invalid-error').hide();
      $('.main-uploadlogo-container').removeClass('invalid-file-error');
      $('.uploaded-photo-div #disallowed').remove();

      var file = input.files[0];
      if ($(input).hasExtension(['.eps', '.ai'])) {
        // Call the Cloudinary upload function to convert the vector file to a PNG
        $('.image-preview-filename').attr('placeholder', '');
        // Render the loading message for the hard goods PDP
        if ($('.hg-product-content').length) {
          $('.image-preview-input').addClass('preview-loading');
          $('.image-preview-input').prepend('<div class="loading-cloudinary-preview">Loading file preview...</div>');
        } else {
          $('.main-uploadlogo-container').prepend('<div class="loading-cloudinary-preview">Loading file preview...</div>');
        }
        const pngUrl = await getPreviewForVectorFile(file);
        if (pngUrl) {
          $('.accord-sr-3 .uploaded-img-span').prepend('<img src='+pngUrl+' />');
          if (preview) {
            preview.setAttribute('src', pngUrl);
            localStorage.setItem('vectorPreview', pngUrl);
          }
          $('.loading-cloudinary-preview').remove();
          $('.image-preview-input').removeClass('preview-loading');;
          $('.main-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
        } else {
          console.error('Failed to upload and convert image');
        }
      } else {
        var reader = new FileReader();
        reader.onload = function (e) {
          $('.accord-sr-3 .uploaded-img-span').prepend('<img src='+e.target.result+' />');
          if (preview) {
            preview.setAttribute('src', e.target.result);
          }
          $('.main-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
        }
        reader.readAsDataURL(file);
      }
      var tempUfileName = (file.name.length > 30) ? file.name.substring(0,30) + '...' : file.name;
      $('.main-uploadlogo-container .uploaded-img-name').text(tempUfileName);
      $('#hidden_upload_your_logo_name').val('');
    }
  } else {
    //preview.setAttribute('src', 'placeholder.png');
    $('.upload-logo-invalid-error').hide();
    $('.main-uploadlogo-container').removeClass('invalid-file-error');
    $('.main-uploadlogo-container').removeClass('photo-exists').attr('data-photo',false);
  }
}


// additional logo -start
function add_showLogoUploadFile(flgVal) {
  if (flgVal == true) {
    $('.additional-uploadlogo-container').show();
  } else {
    $('.additional-uploadlogo-container').hide();
  }
}

function add_showLogoFileBrowse() {
  $('.additional-uploadlogo-container').removeClass('photo-exists').show();
}

function add_cancelEditUploadImg() {
  $('.additional-uploadlogo-container').addClass('photo-exists');
}

function add_setPreviewUploadImage(input) {
    var preview = document.getElementById('preview_additional_uploaded_file');
  if (input.files && input.files[0]) {
      if (typeof($.fn.hasExtension) == 'undefined') {
        $.fn.hasExtension = function(exts) {
          return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', 'ig')).test($(this).val());
        }
      }
      if (!$(input).hasExtension(['.jpg','.jpeg','.png','.gif','.eps','.ai','.svg','.psd'])) {
          $('.upload-logo-second-invalid-error').show();
          $('.additional-uploadlogo-container').addClass('invalid-file-error');
      } else {
          $('.upload-logo-second-invalid-error').hide();
          $('.additional-uploadlogo-container').removeClass('invalid-file-error');
          var reader = new FileReader();
          reader.onload = function (e) {
            $('.accord-sr-4 .uploaded-img-span').prepend('<img src='+e.target.result+' />');
            if (preview) {
              preview.setAttribute('src', e.target.result);
            }
            $('.additional-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
          }
          reader.readAsDataURL(input.files[0]);

          var tempUfileName = (input.files[0].name.length > 30) ? input.files[0].name.substring(0,30) + '...' : input.files[0].name;
          $('.additional-uploadlogo-container .uploaded-img-name').text(tempUfileName);

          $('#hidden_additional_second_logo_name').val('');
      }
  } else {
    $('.upload-logo-second-invalid-error').hide();
      $('.additional-uploadlogo-container').removeClass('invalid-file-error');
    //preview.setAttribute('src', 'placeholder.png');
    $('.additional-uploadlogo-container').removeClass('photo-exists').attr('data-photo',false);
  }
}
// additional logo - end

//tooltip delay
function delayToolTip() {
  if (typeof($.fn.tooltip) != 'undefined') {
    if (typeof($.fn.tooltip.Constructor) != 'undefined') {
      originalLeave = $.fn.tooltip.Constructor.prototype.leave;
      $.fn.tooltip.Constructor.prototype.leave = function(obj) {
        var self = obj instanceof this.constructor ? obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)
        var container, timeout;

        originalLeave.call(this, obj);

        if (obj.currentTarget) {
          container = $(obj.currentTarget).siblings('.tooltip')
          timeout = self.timeout;
          container.one('mouseenter', function() {
            //We entered the actual popover – call off the dogs
            clearTimeout(timeout);
            //Let's monitor popover content instead
            container.one('mouseleave', function() {
              $.fn.tooltip.Constructor.prototype.leave.call(self, self);
            });
          })
        }
      };
    }
  }
}

// Determine the default for decoration type and select it
function selectDefaultDecoType() {
  if (window.location.search.indexOf('gshopping=true') > -1) {
    // Default Google Shopping visitors to 'Sample' (the last decoration type)
    $('input[name="properties[_Decoration type]"]:last').prop("checked", true).change();
  } else {
    // Default to the first decoration type
    $('input[name="properties[_Decoration type]"]:first').prop("checked", true).change();
  }
}

// Selects the first available size if gshopping URL param is found
function selectDefaultSizeForGoogle(){
  if (window.location.search.indexOf('gshopping=true') > -1 && $('.ProductSizeInfo.selected').length == 0) {
    $('.ProductSizeInfo:not(.outOfStock)').first().find('.buttnQtyChange.arrow_triangle-up').click()
  }
}


//Select logo option by default if logo already saved
function selectDefaultLogoOption(){
  var savedLogo = false;
  if(typeof LMTAQA != 'undefined'){
    savedLogo = LMTAQA.getLogoFromStorage();
  }
    if(savedLogo && typeof(savedLogo.isLogoOnFile) != 'undefined' && savedLogo.isLogoOnFile === true){
      $('input[name="properties[_Add embroidered logo ?]"][value="Logo on file"]').prop("checked", true).change();
    }else{
      $('input[name="properties[_Add embroidered logo ?]"][value="Yes"]').prop("checked", true).change();
    }
}

// This function sets equal heights for all jquery selectors listed below.
// It will apply equal height to them on page load and on window resize.
function setAllEqualHeights(){
  var selectors = [
    '.offer-slide-box .custom-table .table-cell',
  ];
  selectors.forEach(function(selector){
    hardEqualHeights(selector);
  });
  $(window).resize(function(){
    selectors.forEach(function(selector){
      hardEqualHeights(selector);
    });
  });
}



// This function set the order to Sample and force max qty to 1
function setSampleOrder(isSample) {
  isSampleOrder = isSample;
  if(isSampleOrder) {
    $('.accord-sr-3 .accord-head').next('.accord-content').slideUp(500);
    $('.accord-sr-3 .accord-head').removeClass('open').addClass('accord-disabled');
    $('.sample-order-disclaimer').show();
    $('input[name=smallQty]').each(function() {
      if(parseInt($(this).val()) > 1) {
        $(this).val(1);
      }
    })
  }
  else {
    $('.sample-order-disclaimer').hide();
  }
}
